module.exports = __webpack_public_path__ + "img/item_down.436f208f.svg";